import EnterPriority from './EnterPriority'

export default EnterPriority
